<template lang="pug">
  .component-configuration-item
    b {{ item.description }} &nbsp;
      span(:style="overridden(item)") [ {{ itemKey }} ]
    .row
      .column.small-11
        // TYPES: string, numeric
        input(type="text", v-if="item.possibile === null && (item.type === 'string' || item.type === 'numeric')", :placeholder="item.default", v-model="value")
        // TYPES: string, numeric but with predefined values
        div(v-else-if="item.possibile !== null && (item.type === 'string' || item.type === 'numeric')")
          select(v-model="value")
            option(:value='null') - NOT SET -
            option(v-for="(p, index) in item.possibile", :value="index") {{ p }}
        // TYPES: array
        div(v-else-if="item.possibile === null && (item.type === 'json')")
          JsonConf(v-model="value")
        div(v-else-if="item.type.split(':')[0] === 'array'")
          // Simple array
          div(v-if="item.type.split(':')[1] === 'simple'")
            div(v-for="pos in item.possibile")
              input(type="checkbox", v-model="value", :value="pos")
              span {{ pos }}
          // Keyed array
          div(v-else-if="item.type.split(':')[1] === 'keyed'")
            .row(v-for="prop, iprop in value")
              DeleteConf(@click="deleteKeyed(iprop)")

              .column.small-4
                input(type="text", :value="iprop", disabled)
              .column
                input(type="text", placeholder="...insert value here...", v-model="value[iprop]")
            select(v-model="selectTmp")
              option(v-for="p in item.possibile", :value="p") {{ p }}
            button.button.small(@click="pushKeyed()") ADD
          // Typed array
          div(v-else)
            .surveys(v-if="itemKey === 'fleet_reservation_surveys'")
              ReservationSurveyConfiguration(:value="value", :item="item")
            .deposit(v-else-if="itemKey === 'commercial_reservation_deposit_config'")
              DepositConfiguration(:value="value", :item="item")
            .custom-fields(v-else-if="itemKey === 'system_client_custom_fields'")
              // ValidationConfig(v-model="value")
              ClientCustomFieldsConfiguration(v-model="value")
            //.system-fields(v-else-if="itemKey === 'system_fields_configuration'")
              SystemFieldsConfiguration(:key="itemKey", v-model="value")
            .fleet-position(v-else-if="itemKey === 'fleet_ignore_user_position_for_vehicle'")
              FleetPositionConfiguration(:value="value", :item="item")
            //.def(v-else-if="!value || value.length === 0")
              .row(v-for="elem, index in item.default")
                .column(v-for="val, inx in elem")
                  input(type="text", :placeholder="inx", :value="item.default[index][inx]", disabled)
            .italian-e-invoice(v-else-if="itemKey === 'italian-e-invoice_split_payments'")
              ItalianEInvoiceSplitPaymentConfiguration(:value="value", :item="item")
            .credit-bonus(v-else-if="itemKey === 'commercial_credit_bonus_configuration'" )
              button.button.small(@click="pushEmptyValue(item.type.split(':')[1].split (','))") Add new bonus
              .row(v-for="(elem, index) in value")
                .column.shrink
                  dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
                    .dropdown-buttons
                      CreditBonusConfiguration(:item="elem", @update="update")
                      button.button(@click="value.splice(index, 1)") Delete
                      CreditBonusInformation(:item="elem", v-if="elem.amount !== null" )
                .column
                  label Name
                  div {{elem.name}}
                .column
                  label Amount
                  div {{elem.amount}}
                .column
                  label Promo amount
                  div {{elem.promo_amount}}

                  //h3 {{elem.value.name}}
              //pre {{item.value}}

            .row(v-else, v-for="(elem, index) in value")
              DeleteConf(@click="value.splice(index, 1)")
              .column(v-for="val, inx in elem")
                input(type="text", :placeholder="inx", v-model="value[index][inx]")
            button.button.small(@click="pushEmptyValue(item.type.split(':')[1].split(','))", v-if="itemKey !== 'commercial_credit_bonus_configuration'" ) ADD
        // TYPES FALLBACK
        div(v-else)
          h1 TYPE NOT MANAGED!
          pre {{ item }}
      .column.small-1
        button.button.small(@click="update") UPDATE
        template(v-if="item._translatable" )
          TranslateField(group="entities", :field="item._translatable")
</template>
<script type="text/babel">
import DepositConfiguration from './configuration/DepositConfiguration'
import ValidationConfig from './configuration/ValidationConfig'
import ClientCustomFieldsConfiguration from './configuration/ClientCustomFieldsConfiguration'
import SystemFieldsConfiguration from './configuration/SystemFieldsConfiguration'
import FleetPositionConfiguration from './configuration/FleetPositionConfiguration'
import DeleteConf from './configuration/DeleteConf'
import ReservationSurveyConfiguration from './configuration/ReservationSurveyConfiguration'
import ItalianEInvoiceSplitPaymentConfiguration from './configuration/ItalianEInvoiceSplitPaymentConfiguration'
import ModalReveal from "../structure/foundation/ModalReveal.vue";
import CreditBonusConfiguration from "./configuration/CreditBonusConfiguration.vue";
import Dropdown from "../structure/foundation/Dropdown.vue";
import CreditBonusInformation from "./configuration/CreditBonusInformation.vue";
import JsonConf from "./configuration/JsonConf.vue";
import TranslateField from "../../pages/backoffice/TranslateField.vue";
//import SplashConfiguration from "./configuration/SplashConfiguration.vue";

export default {
  name: 'ConfigurationItem',
  components: {
    TranslateField,
    JsonConf,
    //SplashConfiguration,
    CreditBonusInformation,
    Dropdown,
    CreditBonusConfiguration,
    ModalReveal,
    ReservationSurveyConfiguration,
    ItalianEInvoiceSplitPaymentConfiguration,
    DeleteConf,
    FleetPositionConfiguration,
    SystemFieldsConfiguration,
    ClientCustomFieldsConfiguration,
    ValidationConfig, DepositConfiguration
  },
  data: function () {
    return {
      value: null,
      selectTmp: null
    }
  },
  created() {
    if (this.item.value) {
      this.value = this.item.value
    } else {
      if (this.item.type.split(':')[1] === 'simple') {
        this.value = this.item.default
      }
    }
  },
  methods: {
    update() {
      console.log(this.item)
      if (this.item.type === "json") {
        try {
          let newFoo = JSON.parse(this.value);
        } catch (err) {
          alert("seems to be invalid json: " + err);

          return
        }
      }
      this.$emit('updateItem', this.itemKey, this.value)
    },
    // Typed array
    pushEmptyValue(fields) {
      if (!this.value) {
        this.value = []
      }

      var item = {}

      fields.forEach(function (fi) {
        item[fi] = null
      })

      this.value.push(item)
    },
    // Keyed array
    pushKeyed() {

      if (this.value === null) {
        this.value = {}
      }

      if (this.selectTmp) {
        this.value[this.selectTmp] = null

        this.reloadValue()
      }
    },
    deleteKeyed(index) {
      delete this.value[index]
      this.reloadValue()
    },
    reloadValue() {
      // Need this to trigger istant re-render
      var tmp = Object.assign({}, this.value)
      this.value = {}
      this.value = Object.assign({}, tmp)
    },
    pushAndSave(item) {
    },
    overridden(item) {
      if (item.hasOwnProperty('has_override') && item.has_override) {
        return {
          color: "red"
        }
      }
      return {}
    }
  },
  props: [
    'item',
    'itemKey'
  ]
}
</script>
<style lang="sass" rel="stylesheet/sass">
.component-configuration-item
  .button
    height: 40px

  .component-selectize .selectize-control.single .selectize-input
    height: 3em
</style>



// WEBPACK FOOTER //
// ConfigurationItem.vue?7ff0aba6